export default __webpack_public_path__ + "static/media/ReactJS.518d6840.jpg";